import React from 'react';
import { useSelector } from 'react-redux';

export default function Loader() {
  const { loading } = useSelector((state) => state.loader);

  if (!loading) return null;

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-[9999]'>
      <div className='relative w-12 h-12'>
        <div className='w-full h-full border-4 border-white/20 border-t-white rounded-full animate-spin'></div>
      </div>
    </div>
  );
}
